import React from 'react';
import { Button } from '../../_atoms/Button';
import { Image } from '../../_atoms/Image';
import PropTypes from 'prop-types';

export const ImageButton = (props) => {
  return (
    <Button type={props.type} onClick={props.onClick} value={props.value}>
      <Image type={props.type} src={props.src} alt={props.alt} />
    </Button>
  );
};

ImageButton.propTypes = {
  type : PropTypes.string,
  src : PropTypes.string.isRequired,
  alt : PropTypes.string.isRequired,
  value : PropTypes.string
};
